$(function () {
  var urlArray = ["products", "journal", "news", "about", "stores"];
  var $dir = location.href.split("/");
  var $dir2 = $dir[$dir.length - 2];
  var navX = $.inArray($dir2, urlArray);
  if (navX != -1) {
    $(".nav__list > li").eq(navX).addClass("selected");
  }
  //,enu hover
  $(".nav__list > li.nav__list--product, .subMenu__inner").mouseover(function (
    e
  ) {
    // ここにマウスオーバー時の処理を記述する
    $("header").addClass("js--hover");
  });
  $(".nav__list > li.nav__list--product, .subMenu__inner").mouseout(function (
    e
  ) {
    $("header").removeClass("js--hover");
  });

  // resizeイベント
  var footerY;
  function setTopSize() {}
  setTopSize.prototype.top = function () {
    var winW = $(window).width(),
      winH = $(window).outerHeight();
    footerY = $("footer").offset().top - winH;
  };
  var resize = new setTopSize();
  $(window).resize(function () {
    resize.top();
  });

  //scroll
  $(window).scroll(function () {
    var scrollY = $(this).scrollTop();
    scrollSet(scrollY);
  });
  function scrollSet(n) {
    if (n >= 40) {
      $("body").addClass("is-header-fixed");
    } else {
      $("body").removeClass("is-header-fixed");
    }
    if (n >= footerY) {
      $(".searchSpBtn").removeClass("show");
      $(".searchSpBtn").removeClass("active");
    } else {
      $(".searchSpBtn").addClass("show");
    }
  }
  setTimeout(function () {
    resize.top();
  }, 1000);

  $(document).on("click touchstart", function (event) {
    if (
      !$(event.target).closest(".searchSpBtn").length &&
      $(".searchSpBtn").hasClass("active")
    ) {
      $(".searchSpBtn").removeClass("active");
    }
  });
  //searchSpBtn
  $('.searchSpBtn .submit').on({'click':function(){
		if(!$('.searchSpBtn').hasClass('active')) {
			$('.searchSpBtn').addClass('active');
			return false;
		} else {
			$('.searchSpBtn').removelass('active');
		}
  }
	});

  //page top
  $(".pageTop").on({
    click: function () {
      gsap.to(window, 0.8, { scrollTo: 0, ease: Power4.easeInOut });
      return false;
    },
  });
  //sp menu open
  $(".menuBtn").on({
    click: function () {
      $("body").toggleClass("menuOpen");
      return false;
    },
  });
  //sp menu click
  $(".subMenu__list > li > dl > dt .link--lineHover .plus").on({
    click: function () {
      $(this).toggleClass("active");
      $(this)
        .parent(".link--lineHover")
        .parent("dt")
        .next("dd")
        .slideToggle(250);
      return false;
    },
  });
  //sp menu img slick
  $(".menuSp__productImg").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
  //News letter
  $(".footer__newsletter--submit button").on({
    click: function () {
      $(".footer__newsletter--submit").addClass("done");
      return true;
    },
  });
  //sns popup
  $("").on({
    click: function () {
      var snsID = $("").index(this);
      if (snsID === 1) {
        fullScreen("http://www.facebook.com/sharer.php?u=" + location.href);
      } else if (snsID === 0) {
        fullScreen(
          "http://twitter.com/share?url=" +
            location.href +
            "&text=" +
            "%23%E3%82%B5%E3%83%B3%E3%83%AA%E3%82%AA%E3%83%8F%E3%83%AD%E3%82%A6%E3%82%A3%E3%83%BC%E3%83%B3"
        );
      }
      return false;
    },
  });
  function fullScreen(theURL) {
    window.open(theURL, "newWin1", "width=600,height=600,scrollbars=yes");
  }

  $(".nav__icon--cart a").on("click", function () {
    $("body").toggleClass("js-CartDrawer-open");
  });
});

$(document).ready(function () {
  Shopify.getCart(function (cart) {
    updateCart(cart);
  });

  $(document).on(
    "click",
    ".button-plus, .button-minus, .button-close",
    function (e) {
      var e = $(this).parent().find('[name="updates[]"]');
      var q = e.val();
      var id = e.prop("id");
      id = id.replace("updates_", "");
      if ($(this).hasClass("button-plus")) {
        q++;
      } else if ($(this).hasClass("button-minus")) {
        q--;
      } else {
        q = 0;
      }
      Shopify.changeItem(id, q);
    }
  );
});

function updateCart(c) {
  console.log(c);
  console.log(c.items);
  $(".CartDrawer__list").empty();

  $(".CartDrawer__checkout dd").text((c.total_price / 100).toLocaleString());

  for (var i = 0; i < c.items.length; i++) {
    var item = c.items[i];
    var productType = item.product_type;

    if(productType == "reserve"){
      var li =
        '<li data-product-type="reserve"><div class="CartDrawer__list--img">\
  	      <a class="block__img" href="' +
        item.url +
        '">\
  	        <span style="background-image: url(' +
        item.featured_image.url +
        ')"></span>\
  	      </a>\
  	    </div>\
  	    <div class="CartDrawer__list--info">\
  	      <dl class="font-r">\
  	        <dt><a href="/products/detail/">' +
        item.title +
        "</a></dt>\
  	        <dd>" +
        (item.price / 100).toLocaleString() +
        '</dd>\
  	      </dl>\
  	      <div class="cart__list--info--unm">\
  					<button class="button-plus" type="button"><span>+</span></button>\
  					<input type="number" name="updates[]" id="updates_' +
        item.id +
        '" min="0" value="' +
        item.quantity +
        '">\
  					<button class="button-minus" type="button"><span>-</span></button>\
  					<button class="button-close" type="button" ><span>×</span></button>\
  	      </div>\
  	    </div>\
  	  </li>';
    }else{
      var li =
        '<li><div class="CartDrawer__list--img">\
          <a class="block__img" href="' +
        item.url +
        '">\
            <span style="background-image: url(' +
        item.featured_image.url +
        ')"></span>\
          </a>\
        </div>\
        <div class="CartDrawer__list--info">\
          <dl class="font-r">\
            <dt><a href="/products/detail/">' +
        item.title +
        "</a></dt>\
            <dd>" +
        (item.price / 100).toLocaleString() +
        '</dd>\
          </dl>\
          <div class="cart__list--info--unm">\
            <button class="button-plus" type="button"><span>+</span></button>\
            <input type="number" name="updates[]" id="updates_' +
        item.id +
        '" min="0" value="' +
        item.quantity +
        '">\
            <button class="button-minus" type="button"><span>-</span></button>\
            <button class="button-close" type="button" ><span>×</span></button>\
          </div>\
        </div>\
      </li>';
    }
    $(".CartDrawer__list").append(li);
  }

  //クイックカート Close
  $(document).on(
    "click touchstart",
    ".CartDrawer__contents .close",
    function () {
      $("body").removeClass("js-CartDrawer-open");
    }
  );

  $(document).on("click touchstart", function (event) {
    //console.log($('body').hasClass('js-CartDrawer-open'))
    console.log($(this));
    if (
      !$(event.target).closest(".CartDrawer").length &&
      !$(event.target).closest(".produce__form--btn--input input.submit")
        .length &&
      !$(event.target).closest(".nav__icon--cart").length &&
      $("body").hasClass("js-CartDrawer-open")
    ) {
      $("body").removeClass("js-CartDrawer-open");
    }
  });
}  
//言語モーダル
var localstorage = 'nap3';
const currentPath = window.location.pathname;
const modifiedPath = currentPath.replace('en/','');

console.log(modifiedPath);
    splashDom = `<div class="langModal"><div class="langModal__contents"><p class="langModal__contents--title"><span class="langModalText--jp">こんにちは。言語を選択してください</span><span class="langModalText--en">Hello, Select your language</span></p><ul class="langModal__btnList font-sb"><li class="btn block btn_japanese"><a href="${modifiedPath.replace('en/','')}">Japanese</a></li><li class="btn block btn_english"><a href="/en${modifiedPath}">English</a></li></ul><p class="langModal__contents--text"><span class="langModalText--jp">ページ下部から言語変更も可能です。</span><span class="langModalText--en">You can also change the language <br class="brSp">from the bottom of the page.</span></p><div class="close"><span></span></div></div></div>`;

if (!localStorage.getItem(localstorage)) {
    $('body').append(splashDom).addClass('langModal--open');
    if(document.URL.match("/en")) $('.langModal').addClass('langModal--en');
    $('.langModal__btnList li').on({'click':function(){
        localStorage.setItem(localstorage, 'checked');
        }
    });
    $('.langModal__contents .close').on({'click':function(){
        $('body').removeClass('langModal--open');
        }
    });
    $(document).on('click touchstart', function(event) {
        if (!$(event.target).closest('.langModal__contents').length && $('body').hasClass('langModal--open')) {
            $('body').removeClass('langModal--open');
        }
    });
}

window.addEventListener('load',()=> {
  if (!localStorage.getItem(localstorage)) {
    if(document.URL.match("/en")) {
      const japaneseBtnLink = document.querySelector('.btn_japanese a');
      japaneseBtnLink.href = japaneseBtnLink.href.replace('en/','');
    }
  }
})

//検索フォームをクリックで表示・非表示切り替え
const searchIcon = document.querySelector('.nav__icon--search');
const searchForm = document.querySelector('.searchHover');

searchIcon.addEventListener("click", function() {
  searchForm.classList.toggle("visible"); 
  searchIcon.classList.toggle("selected"); 
});

searchForm.addEventListener("click", function(event) {
  event.stopPropagation();
});